import { Link } from 'react-router-dom';

interface SiteLogoProps {
  className?: string;
}

function SiteLogo({ className = '' }: SiteLogoProps) {
  return (
    <Link to="/" className={`flex items-center gap-2.5 cursor-pointer ${className}`}>
      <span className="relative w-9 h-9 rounded-md bg-foreground-950 flex items-center justify-center">
        <span className="w-5 h-5 flex items-center justify-center">
          <i className="ri-line-chart-line text-primary-400 text-[17px]"></i>
        </span>
        <span className="absolute bottom-1 right-1 w-1.5 h-1.5 rounded-full bg-primary-500"></span>
      </span>
      <span className="font-heading font-extrabold text-[18px] tracking-tight text-foreground-950 leading-none">
        GOLD<span className="text-primary-500">EA</span>
      </span>
    </Link>
  );
}

export default SiteLogo;